import { isValidElement, MutableRefObject, ReactElement, Ref, useMemo } from "react";

export function isReactElement(x: unknown): x is ReactElement {
  return isValidElement(x);
}

let currentId = 1;

export function useElementId(id?: string) {
  return useMemo(() => id ?? `element-${currentId++}`, [id]);
}

export function mergeRefs<T>(
  ...refs: (((x: T | null) => void) | MutableRefObject<T | null> | Ref<T | null> | undefined)[]
) {
  return (x: T | null) => {
    for (const ref of refs) {
      if (typeof ref === "function") {
        ref(x);
      } else if (ref) {
        (ref as MutableRefObject<T | null>).current = x;
      }
    }
  };
}
